import { GoJsProductColors } from '@y42/gojs';
import { Y42FeatureType } from '@y42/json-schema';
import { Y42FeatureTypeToLabel, Y42FeatureTypeToLogo } from '../../models';

export type GoJSLegendPosition = 'right-with-sidebar' | 'right-without-sidebar';

export interface GoJsLegend {
  color: string;
  icon: string;
  name: string;
}

type Y42GoJsNodeType =
  | Y42FeatureType.Integration
  | Y42FeatureType.UiModel
  | Y42FeatureType.SqlModel
  | Y42FeatureType.Export
  | Y42FeatureType.VisualizationDashboard
  | Y42FeatureType.VisualizationWidget;

export const legendsByColorScheme = (isDarkTheme = false): Record<Y42GoJsNodeType, GoJsLegend> => {
  return {
    [Y42FeatureType.Integration]: {
      name: Y42FeatureTypeToLabel[Y42FeatureType.Integration].plural,
      icon: Y42FeatureTypeToLogo[Y42FeatureType.Integration],
      color: isDarkTheme ? GoJsProductColors.Dark.Integration : GoJsProductColors.Light.Integration,
    },
    [Y42FeatureType.UiModel]: {
      name: Y42FeatureTypeToLabel[Y42FeatureType.UiModel].plural,
      icon: Y42FeatureTypeToLogo[Y42FeatureType.UiModel],
      color: isDarkTheme ? GoJsProductColors.Dark.Model : GoJsProductColors.Light.Model,
    },
    [Y42FeatureType.SqlModel]: {
      name: Y42FeatureTypeToLabel[Y42FeatureType.SqlModel].plural,
      icon: Y42FeatureTypeToLogo[Y42FeatureType.SqlModel],
      color: isDarkTheme ? GoJsProductColors.Dark.Model : GoJsProductColors.Light.Model,
    },
    [Y42FeatureType.Export]: {
      name: Y42FeatureTypeToLabel[Y42FeatureType.Export].plural,
      icon: Y42FeatureTypeToLogo[Y42FeatureType.Export],
      color: isDarkTheme ? GoJsProductColors.Dark.Export : GoJsProductColors.Light.Export,
    },
    [Y42FeatureType.VisualizationDashboard]: {
      name: Y42FeatureTypeToLabel[Y42FeatureType.VisualizationDashboard].plural,
      icon: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationDashboard],
      color: isDarkTheme ? GoJsProductColors.Dark.Visualization : GoJsProductColors.Light.Visualization,
    },
    [Y42FeatureType.VisualizationWidget]: {
      name: Y42FeatureTypeToLabel[Y42FeatureType.VisualizationWidget].plural,
      icon: Y42FeatureTypeToLogo[Y42FeatureType.VisualizationWidget],
      color: isDarkTheme ? GoJsProductColors.Dark.Widget : GoJsProductColors.Light.Widget,
    },
  };
};
